import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { styled } from 'decentraland-ui2'

const ErrorMessageIcon = styled(ErrorOutlineIcon)({
  color: '#fb3b3b'
})

export { ErrorMessageIcon }
